export default defineNuxtRouteMiddleware(async (to, from) => {
  const nuxtapp = useNuxtApp()
  const userStore = useUserStore(nuxtapp.$pinia)

  // TODO: server side check permission
  console.log('middleware', { to: to.path, token: userStore.token })

  if (!userStore.token)
    return navigateTo('/login')
})
